import React, { useEffect, useState } from "react";
import styles from "./login.module.scss";

import { useForm } from "react-hook-form";

import { Button } from "../../components/ui/buttons/Button";
import { Link, useNavigate } from "react-router-dom";

import { sendResetPasswordEmail } from "../../api/product-service";
import LoginContent from "../../components/common/LoginContent";

// assets
import { ROUTES } from "../../routes";
import { toast } from "react-toastify";
import { MoxeyBrandLogo } from "./login";

function ForgotPasswordPage() {
  return (
    <>
      <div className={styles.app_login_wrapper}>
        <ForgotPasswordForm />
        <div className={styles.content}>
          <LoginContent />
        </div>
      </div>
    </>
  );
}

export const ForgotPasswordForm = () => {
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // Send Reset Password Email
  const handleFormSubmit = (formData) => {
    setloading(true);
    const { email } = formData;

    sendResetPasswordEmail({ email })
      .then((res) => {
        toast(res.data.message, { type: "success" });
        reset();
        setloading(false);
        navigate(ROUTES.LOGIN);
      })
      .catch((err) => {
        setloading(false);
      });
  };
  return (
    <form
      className={styles.app_login_form}
      onSubmit={handleSubmit(handleFormSubmit)}
    >
      {/* moxey brand logo */}
      <div className="text-center mb-5">
        <MoxeyBrandLogo />
        <h5 className="text-dark my-5">Forgot Password ?</h5>
        <div className="alert alert-info">
          Don't worry! Resetting your password is easy. Just type in the email
          you registered to Moxey.
        </div>
      </div>
      <fieldset disabled={loading}>
        <label
          htmlFor="input-username"
          className="form-label text-start required"
        >
          Email Address
        </label>
        <div className="mb-3">
          <input
            id="input-email"
            {...register("email", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            className={`form-control form-control-lg ${
              errors.email ? "is-invalid" : ""
            }`}
            type="text"
          />
          <div className="invalid-feedback text-start">
            {errors.email && errors.email.message}
          </div>
        </div>
      </fieldset>

      <div className="form-group mb-3">
        <Button
          text={"Submit"}
          loading={loading}
          className="btn btn-lg btn-primary  w-100"
          type="submit"
        />
      </div>

      <div className="form-group mb-3">
        <Link to={ROUTES.LOGIN} className="btn btn-link w-100">
          Back to Login
        </Link>
      </div>
    </form>
  );
};

export default ForgotPasswordPage;
